<template>
  <v-container
    style="width: 100%;"
    fluid>
    <v-row>
      <v-col
        cols="12">
        <ReportFilter
          ref="ReportFilter"
          :filtersForCheckDate="filtersForCheckDate"
          @handlerClickFilter="handlerClickFilter"
          @clearFilters="clearFilters"

          :resetFilterMyReports="resetFilterMyReports"
          @hasFiltersMyReports="hasFiltersMyReports"
          @updateDates="updateDates"
        />
      </v-col>

      <v-col
        cols="12"
        class="px-0">
        <ReportTable
          ref="MyReportsTable"
          :filter="filterMyReports"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import ReportFilter from '@/components/Report/ReportFilter.vue';
import ReportTable from '@/components/Report/ReportTable.vue';
import ReportMixin from '@/shared/mixins/report/reportMixin';
import { cloneDeep } from 'lodash';
import moment from 'moment';

export default {
  name: "SearchInsuredReport",

  components: {
    ReportFilter,
    ReportTable,
  },

  data: () => ({
    resetFilterMyReports: false,
    filterForCheckMyReports: {},
    filtersForCheckDate: {},
    financialGroups: [],
    dates: [],
  }),

  mixins: [
    MovementRecordsMixin,
    ReportMixin,
  ],


  props: {
    tab: {
      type: String,
    }
  },

  watch: {
    tab: {
      handler(tabValue) {
        if (tabValue === 'reports') {
          const reportFilterRef = this.$refs.ReportFilter;
          if (reportFilterRef) reportFilterRef.handlerFilter();
        }
      },
    }
  },

  methods: {
    handlerClickFilter(dates) {
      if (dates && dates.length > 0) {
        this.processDates(dates);
      } else {
        this.dates = [];
      }
      const commonFilterProperties = {
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      };
      this.handleMyReports(commonFilterProperties);
    },
    updateDates(dates) {
      this.processDates(dates);
      this.filterMyReports = {
        ...this.filterMyReports,
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      }
      this.dataFilterMyReports = cloneDeep(this.filterMyReports);
    },
    processDates(dates) {
      const startDate = moment(dates[0]);
      const endDate = moment(dates[1]);
      this.dates[0] = this.setDateTimezone(startDate.startOf('day'))
      this.dates[1] = this.setDateTimezone(endDate.endOf('day').add(3, 'hours'))
      this.dates[0] = this.formatDate(this.dates[0])
      this.dates[1] = this.formatDate(this.dates[1])
    },
    setDateTimezone(date) {
      return date.add(3, 'hours')
    },
    formatDate(date) {
      return date.format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    clearFilters() {
      this.resetFilterMyReports = true;
    },
    handleMyReports(commonFilterProperties) {
      this.resetFilterMyReports = false;
      this.filterMyReports = {
        ...this.dataFilterMyReports,
        ...commonFilterProperties,
      }
      setTimeout(() => {
        this.$refs.MyReportsTable.handlerFilter(this.filterMyReports, 'click');
      }, 200);
    },
    hasFiltersMyReports(data) {
      this.dataFilterMyReports = cloneDeep(data);
      this.filterMyReports = {
        ...this.filterMyReports,
        ...this.dataFilterMyReports
      }
    },
  },
}
</script>